import React, {Component} from "react"

import mainTheme from "@irati/ui/src/global/theme"
import {H6, Body} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import authentication from "@irati/auth"
import {CelebrationsReportCategory, CelebrationsReportDuration, CelebrationsReportPollWinner, CelebrationsReportPoll} from "@irati/types"
import Loading from "@irati/ui/src/Loading"
import Spacing from "@irati/ui/src/Spacing"

import TimeRange from "../TimeRange"
import PollWinnersCard from "../PollWinnersCard"
import Region, {ALL_TEAMS} from "../../../Region"
import ShareLink from "../../../../ShareLink"
import EmptyPolls from "./../EmptyPolls"
import Download from "./Download"

interface Props extends InjectIntl {}

interface State {
  regionId: string
  duration: CelebrationsReportDuration
  category: CelebrationsReportCategory
  load: Promise<void> | null
  users: CelebrationsReportPollWinner[]
  polls: CelebrationsReportPoll[]
}

class CelebratedPolls extends Component<Props, State> {
  state = {
    regionId: ALL_TEAMS,
    duration: CelebrationsReportDuration.CelebrationsLast_90Days,
    category: CelebrationsReportCategory.Polls,
    load: null,
    users: [],
    polls: []
  }

  componentDidMount(): void {
    this.getCelebrationReport()
  }

  getCelebrationReport = () => {
    const {regionId, duration, category} = this.state
    const regionIds = regionId !== ALL_TEAMS ? [regionId] : undefined

    const load = adminReportingService
      .getCelebrationsReport({
        businessId: authentication.business().uuid,
        regionIds,
        duration,
        category,
        limit: 5
      })
      .then((res) => {
        this.setState({users: res.polls.winners, polls: res.polls.polls})
      })
    this.setState({load})
  }

  handleUpdateRegion = (regionId: string) => {
    this.setState({regionId}, this.getCelebrationReport)
  }

  handleSetTimeRangeUpdate = (duration: CelebrationsReportDuration) => {
    this.setState({duration}, this.getCelebrationReport)
  }

  render() {
    const {regionId, duration, category, load, users} = this.state

    return (
      <Spacing marginBottom={3}>
        <Flex justifyContent="space-between" marginBottom={3}>
          <Flex direction="column" maxWidth="360px">
            <H6 marginBottom>
              <FormattedMessage id="admin.reporting.celebrations.polls.title" />
            </H6>
            <Body small>
              <FormattedMessage id="admin.reporting.celebrations.polls.body" />
            </Body>
          </Flex>
          <Flex direction="column">
            <Flex alignItems="center" gap={mainTheme.spacing.oneAndHalf} justifyContent="flex-end" marginTop={1}>
              <ShareLink />
              <Region id="adminSection_celebrations_country" value={regionId} onChange={this.handleUpdateRegion} />
              <TimeRange onChange={this.handleSetTimeRangeUpdate} value={duration} />
            </Flex>
          </Flex>
        </Flex>
        <H6 marginBottom>
          <FormattedMessage id="admin.reporting.celebrations.polls.mostPopularPolls.title" />
        </H6>
        <Loading load={load}>
          <Flex gap={mainTheme.spacing.two} marginBottom={3} wrap="wrap">
            {users.map((user, index) => (
              <PollWinnersCard pollWinnerUser={user} index={index} />
            ))}
          </Flex>
          {users.length === 0 && <EmptyPolls />}
          <Download category={category} duration={duration} regionId={regionId} hideText />
        </Loading>
      </Spacing>
    )
  }
}

export default injectIntl(CelebratedPolls)
